"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilter = useFilter;
const react_1 = require("react");
const utils_1 = require("../utils");
function useFilter({ filterDefs }) {
    const [filter, setFilter] = (0, react_1.useState)(Object.fromEntries((0, utils_1.safeEntries)(filterDefs)
        .filter(([key, def]) => def(key).defaultValue !== undefined)
        .map(([key, def]) => [key, def(key).defaultValue])));
    return { setFilter, filter };
}
